import request from '@/utils/request'
import qs from 'qs'

export function login(data) {
  return request.post('api/user/login', qs.stringify(data))
}
export function preLogin(data) {
  return request.post('api/login/pre-login', qs.stringify(data))
}
export function logout() {
  return request({
    url: '/api/user/logout',
    method: 'get'
  })
}

export function editUserService(data) {
  return request({
    url: 'api/user/edit',
    method: 'post',
    data: data
  })
}

export function getUserListService(data) {
  return request({
    url: 'api/user/list',
    method: 'post',
    data
  })
}
export function getCompanyAdminListService(data) {
  return request({
    url: 'api/user/queryCompanyAdminList',
    method: 'POST',
    data
  })
}

export function addUserService(data) {
  return request({
    url: 'api/user/add',
    method: 'post',
    data: data
  })
}

export function enableUserService(data) {
  return request({
    url: 'api/user/enable',
    method: 'get',
    params: data
  })
}

export function disableUserService(data) {
  return request({
    url: 'api/user/disable',
    method: 'get',
    params: data
  })
}

export function deleteUserService(data) {
  return request({
    url: 'api/user/delete',
    method: 'get',
    params: data
  })
}
export function deletePasswordUserService(data) {
  return request({
    url: 'api/user/delete_password_user',
    method: 'get',
    params: data
  })
}
export function getAccountInfoService(data) {
  return request({
    url: 'api/user/accountinfo',
    method: 'get',
    params: data
  })
}

export function saveAccountInfoService(data) {
  return request({
    url: 'api/user/editaccount',
    method: 'post',
    data: data
  })
}

export function resetPawService(data) {
  return request({
    url: 'api/user/restpwd',
    method: 'post',
    data: data
  })
}
export function changePwdService(data) {
  return request({
    url: 'api/user/changePwd',
    method: 'post',
    data: data
  })
}
export function getQrCodeService(data) {
  return request({
    url: 'api/apply/getQrCode',
    method: 'get',
    params: data
  })
}

export function createQrCodeService(data) {
  return request({
    url: 'api/apply/createQrCode',
    method: 'post',
    data: data
  })
}

export function getAccountQrCode(params) {
  return request({
    url: 'api/wechat/qr-code',
    method: 'get',
    params
  })
}

export function getBindInfo(params) {
  return request({
    url: 'api/wechat/bind-info',
    method: 'get',
    params
  })
}

export function cancelUserBind(params) {
  return request({
    url: 'api/wechat/cancel-bind',
    method: 'get',
    params
  })
}

export function getIsComplete() {
  return request({
    url: 'api/serverUser/isComplete',
    method: 'get'
  })
}

export function getCode(data) {
  return request({
    url: 'api/retrieve/getMobileCode',
    method: 'post',
    data
  })
}

export function verifyMobileCode(data) {
  return request({
    url: 'api/user_info/verifyMobileCode',
    method: 'post',
    data
  })
}

export function editMobile(data) {
  return request({
    url: 'api/user_info/editMobile',
    method: 'post',
    data
  })
}

export function getEmailCode(data) {
  return request({
    url: 'api/user_info/getEmailCode',
    method: 'post',
    data
  })
}

export function verifyEmailCode(data) {
  return request({
    url: 'api/user_info/verifyEmailCode',
    method: 'post',
    data
  })
}

export function editEmail(data) {
  return request({
    url: 'api/user_info/editEmail',
    method: 'post',
    data
  })
}

// 清除缓存
export function clearCache(data) {
  return request({
    url: 'api/sys_manage/initAll',
    method: 'post',
    data
  })
}
